import { ValidatorFn, ValidationErrors, AbstractControl } from '@angular/forms';

export function depositValidator(): ValidatorFn {
  return (form: AbstractControl): ValidationErrors | null => {
    const amount = form.get('payment');
    const date = form.get('date');

    if (date?.dirty && date?.valid) {
      if (!amount?.value) {
        amount?.markAsTouched();
        amount?.markAsDirty();
        amount?.setErrors(amount.value === 0 ? { min: { actual: 0 } } : { required: true });
        return amount?.value === 0 ? { min: { actual: 0 } } : { required: true };
      }
      amount?.setErrors(null);
    }

    return null;
  };
}
